export default "__VITE_ASSET__DzAX0F_M__"